import React, { Children } from 'react';
import PageSubSection from '../layout/PageSubSection';
import TextBlock from '../TextBlock';
import { DefinitionBlock, Heading, Text, WYSIWYG } from '../../util/typography';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { createMarkup } from '../../util/functions';
import * as colors from '../../util/colors';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

const MoaContent = styled(WYSIWYG)`
&, & * {
    color: ${colors.ink} !important;
}

margin-bottom: 20px;`;

const Definitions = styled.div`
margin-top: 10px;

@media (max-width: 765px) {
margin-top: 20px;
}
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 13px;

    > div {
        flex-basis: 33.3%;
        min-width: 280px;
        max-width: calc(50% - 10px);
        flex: 1;
        @media(max-width: 620px){
            max-width: 100%;
        }
    } 
        
    @media (max-width: 765px){
        gap: 20px;
    }
`;

const ImageWrapper= styled.div`
border-radius: 8px 8px 0 0;
overflow: hidden;

height: ${({deskImgHeight}) => deskImgHeight || '221px'};
object-fit: contain;

@media (max-width: ${NAVIGATION_BREAKPOINT}){
height: ${({mobImgHeight}) => mobImgHeight || '193px'};
}
`;

const Wrapper = styled.div`
box-sizing: border-box;
display: flex;
flex-direction: column;
height: 100%;
`;

const ContentWrapper = styled.div`
padding: 20px;
border-radius: 0 0 8px 8px;
flex: 1;

    > h4 {
        margin-bottom: 6px;
    }

    @media (max-width: 765px) {
        > h4 {
            margin-bottom: 4px;
        }
    }

${({type}) => type === "qlex" ? `
    border: 0.5px solid ${colors.darkPurple};
    background: ${colors.extraLightPurple};
` : `
    border: 0.5px solid ${colors.keytrudaGreenWeb};
    background: ${colors.keytrudaGreenBackground};
`}
`;

const Body = styled(Text.Body)`
color: ${colors.ink};
`;

function MOACard (props){
    return (
        <>
           {props.description && <MoaContent  dangerouslySetInnerHTML={{ __html: props.description }} />}
           {props.cards && 
                <Row>
                    {props.cards.map((card, index) => {
                        return (
                        <div>
                            <Card {...card} type={props.type} deskImgHeight={props.deskImgHeight} mobImgHeight={props.mobImgHeight} />
                        </div>)})}
                </Row>
           }
           {props.def && 
                <Definitions>
                        <DefinitionBlock text={props.def} />
                </Definitions>
            }
        </>
    )
}

function Card (props) {
       
    return(
    <Wrapper>
        {props.image && 
            <ImageWrapper deskImgHeight={props.deskImgHeight} mobImgHeight={props.mobImgHeight}>
                {typeof props.image === 'function' && props.image()}
            </ImageWrapper>
        }
        <ContentWrapper type={props.type}>
            <Heading.H4 dangerouslySetInnerHTML={createMarkup(props.caption)} />
            <Body>{props.description}</Body>
        </ContentWrapper>

    </Wrapper>
)
}

export default MOACard;